module.exports = __webpack_public_path__ + "components/home-header/static/header-4--medium-1720a8d8f654a3b4bc17ee014bac18b2.jpg";